import { fetchCurrentUser, fetchArchiveLocations, fetchMyArchiveLocations } from "./accountsService";

export async function getUserWithLocations(projectId, params = {}) {
    const user = await fetchCurrentUser();
    const locations = user.role === "student"
        ? await fetchMyArchiveLocations(projectId, params)
        : await fetchArchiveLocations(projectId, params);
    return { user, locations };
}
